import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Image icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Image } from '@sravni/design-system-icons'
 *
 * <Image />
 * ```
 */
var Image = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Image", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15 3.571H5c-.79 0-1.429.64-1.429 1.429v10c0 .789.64 1.429 1.429 1.429h10c.789 0 1.428-.64 1.428-1.429V5c0-.789-.64-1.429-1.428-1.429Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.5 8.571a1.071 1.071 0 1 0 0-2.142 1.071 1.071 0 0 0 0 2.142ZM16.429 12.143 12.857 8.57 5 16.43", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Image };
//# sourceMappingURL=Image.js.map
